<script setup lang="ts">
import type { BlockCard, BlockButtonGroup } from '~/types';
import type { File } from '~/types/system/file';

const props = defineProps<{
  data: BlockCard;
}>();

const customIcon = computed(() => {
  if (!props.data.custom_icon && !props.data.icon) {
    return '';
  } else if (props.data.custom_icon) {
    return props.data.custom_icon;
  } else {
    return `material-symbols:${props.data.icon}`;
  }
});

const imageFile = computed(() => {
  if (props.data?.image && typeof props.data.image === 'object') {
    return props.data.image as File;
  }
  return null;
});
</script>
<template>
  <UCard
    v-if="data"
    :ui="{
      root: 'relative group isolate rounded-xl ring-1 ring-primary-200 dark:ring-primary-800 flex-1 flex flex-col shadow transition-shadow duration-200 hover:ring-totem-pole-500 dark:hover:ring-totem-pole-400',
      body: 'px-4 py-5 sm:p-6 gap-x-8 gap-y-4 rounded-xl flex-1 flex flex-col min-h-[257px] bg-white dark:bg-white hover:bg-opacity-90 dark:hover:bg-opacity-90 transition-[background-opacity]',
    }"
  >
    <div>
      <div v-if="customIcon" class="mb-2 pointer-events-none text-center">
        <UIcon
          :name="customIcon"
          class="size-8 shrink-0 text-totem-pole-500 dark:text-totem-pole-500"
        />
      </div>
      <h3 class="text-black dark:text-black text-base font-bold truncate">{{ data.title }}</h3>
      <p class="text-[15px] text-black dark:text-black mt-1">{{ data.description }}</p>
    </div>
    <BlocksButtonGroup v-if="data.button_group" :data="data.button_group as BlockButtonGroup" />
    <NuxtImg
      v-if="imageFile"
      class="w-full overflow-hidden dark:brightness-90 max-h-[500px] rounded-md"
      :src="imageFile.id"
      :alt="imageFile.description ?? data.title ?? 'Hero Image'"
      :title="imageFile.description ?? undefined"
      width="500"
      placeholder
    />
  </UCard>
</template>
